<template>
    <checkbox :value="value" @input="$emit('input', $event)">
        <slot name="message">
            <message msgKey="register.agree">
                <template #arg0>
                    <button
                        class="px-2 text-blue underline"
                        @click="showTerms = true"
                    >
                        {{ $t('register.terms') }}
                    </button>
                    <termsModal v-if="showTerms" @close="showTerms = false">
                        <termsOfUse />
                    </termsModal>
                </template>
                <template #arg1>
                    <button
                        class="px-2 text-blue underline"
                        @click="showPrivacy = true"
                    >
                        {{ $t('register.privacy') }}
                    </button>
                    <termsModal v-if="showPrivacy" @close="showPrivacy = false">
                        <privacyPolicy />
                    </termsModal>
                </template>
            </message>
        </slot>
    </checkbox>
</template>

<script>
import checkbox from './checkbox.vue';
import { message } from '@/utils/getMessage';
import termsModal from './termsModal.vue';
import pageLoader from './pageLoader.vue';

export default {
    components: {
        checkbox,
        message,
        termsModal,
        termsOfUse: () => ({
            loading: pageLoader,
            component: import('@/components/termsOfUseContent.vue')
        }),
        privacyPolicy: () => ({
            loading: pageLoader,
            component: import('@/components/privacyPolicyContent.vue')
        })
    },
    props: {
        value: {}
    },
    data() {
        return {
            showTerms: false,
            showPrivacy: false
        };
    }
};
</script>
